import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex text-center flex-column flex-md-row flex-grow-1" },
    [
      _vm.isUserLoading
        ? _c(
            "div",
            { staticClass: "loading-user" },
            [
              _c(VProgressLinear, {
                attrs: { indeterminate: "", color: "blue darken-2" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "pa-2 pa-md-4 flex-grow-1 align-center justify-center d-flex flex-column",
        },
        [
          _c(
            "div",
            { staticClass: "layout-content ma-auto w-full" },
            [_vm._t("default")],
            2
          ),
          _c("div", { staticClass: "overline mt-4" }, [
            _vm._v(
              _vm._s(_vm.product.name) + " - " + _vm._s(_vm.product.version)
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }